import { LoraDevicesApiClient } from '../services/api/loraDevices';

let client: LoraDevicesApiClient;

const loraDevicesFactory = () => (client = new LoraDevicesApiClient());

/**
 * @deprecated Use `useServices` hook instead.
 */
export const getLoraDevicesApi = (): LoraDevicesApiClient => client ?? loraDevicesFactory();
